.dialog {
  position: fixed;
  top: 10vh;
  left: 50%;

  transform: translateX(-50%);

  box-sizing: border-box;
  width: min(600px, 90vw);
  max-height: calc(90vh - 1rem);
  display: flex;
  flex-direction: column;
  padding-inline: 1rem;

  background-color: $gray-1250;
  color: $ui-white;
  border-radius: 3px;
  box-shadow: $box-shadow-l1;
  border: 1px solid $gray-1100;
  outline: none;
}

.backdrop {
  position: fixed;
  inset: 0;
  background-color: $backdrop-color;
  transition: opacity 300ms cubic-bezier(0.45, 1.005, 0, 1.005);

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
  }
}

.title {
  font-size: 1rem;
  font-weight: 600;
  padding-block: 1rem;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.footer {
  padding-block: 1rem;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 1rem;
  flex-wrap: wrap;
}
